import { render, staticRenderFns } from "./CommonAttachmentTextfield.vue?vue&type=template&id=4f8cf37d"
import script from "./CommonAttachmentTextfield.vue?vue&type=script&lang=js"
export * from "./CommonAttachmentTextfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports